// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__yJXt7","pageTab":"NavBar_pageTab__mrEjI","pageTab_active":"NavBar_pageTab_active__mHhXB","pageTab_inactive":"NavBar_pageTab_inactive__7vMo1"};